import { useEffect, useState } from "react";
import { getRole } from "../../api/users";
import SpecsSpace from "../../components/Specs/SpecsAll";

export default function SpecsPage() {
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const token = localStorage.getItem("access_token");

    if (!token) {  //this is REQUIRED for non-logged in users otherwise the page will give 401 which will redirect to login
      setIsAdmin(false);
      setLoading(false);
      return;
    }

    const checkAdmin = async () => {
      try {
        const roleData = await getRole();
        setIsAdmin(roleData.role === "admin" || roleData.role === "superadmin");
      } catch (error) {
        console.error("Error checking user type:", error);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdmin();
  }, []);

  if (loading) {
    return <p className="text-center mt-10">Loading...</p>;
  }

  return <SpecsSpace mode={isAdmin ? "admin" : "user"} />;
}
